export const BlankContainer = ({children})=>{
return <div className="bg-white flex-grow h-fit pb-3 px-3.5">
{/* <div className="bg-white h-fit p-3 flex-grow"> */}
{children}
</div>
}